import styled from "styled-components"

export const StyledAllergens = styled.div`
  font-style: italic;
`
